export default __webpack_public_path__ + "images/OM.da98565.png";